import { Maybe } from '../../types/generated-types';

interface DeviceMetric {
  value?: Maybe<number | string | boolean> | number | string | undefined | null;
  units?: Maybe<string> | string | undefined | null;
  timestamp?: Maybe<number | string> | undefined | null;
}

export function formatDeviceMetric(
  metric: DeviceMetric | undefined | null,
  defaultUnits?: string,
): string {
  if (!metric?.value) return 'N/A';

  const value =
    typeof metric.value === 'number'
      ? metric.value.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      : metric.value;

  const units = metric.units || defaultUnits || '';

  return units ? `${value} ${units}` : `${value}`;
}
